<template>
  <div>
    <div class="mt-4">
      <div class="pa-2 wrapper-1 ma-2 groups-wrapper">
        <div class="d-flex align-center justify-space-between mb-2">
          <div>
            <span class="fs-1r"
              >{{ parent === 'user' ? $t('Groups') : 'Groups' }}:</span
            >
          </div>
          <div>
            <Button
              :clickAction="addGroupClicked"
              :text="parent === 'user' ? $t('Add Group') : 'Add Group'"
              class="mx-1"
            />
          </div>
        </div>

        <TableHeader :user="user" :parent="parent" />
        <TableRow
          :user="user"
          :sftpDetailsUploadingClicked="v => sftpDetailsUploadingClicked(v)"
          @sftpDetailsUploadingClicked="sftpDetailsUploadingClicked"
          @groupClicked="item => (casualGroupAddEdit = item)"
          :parent="parent"
        />
      </div>
    </div>
    <AddEditCasualGroupPopUp
      v-if="casualGroupAddEdit"
      :closeDialog="() => (casualGroupAddEdit = false)"
      :casualGroupAddEdit="casualGroupAddEdit"
      :saveCasualGroupPopUp="saveCasualGroupPopUp"
      :casualUsers="loggedUserCasualsData"
      :casualGroups="loggedUserGroupsData"
      :parent="parent"
    />
  </div>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import AddEditCasualGroupPopUp from '../AddEditCasualGroupPopUp.vue'
import SftpDetailsDialog from '../../../SingleOrganization/Routes/SingleRoute/Children/SourceOrTargetItem/Childrens/SftpDetailsDialog/SftpDetailsDialog.vue'
import TableHeader from '../CasualGroups/Children/TableHeader.vue'
import TableRow from '../CasualGroups/Children/TableRow.vue'
import { api } from '@/config'
import { confirmDialog } from '@/utils'
import { mapMutations } from 'vuex'

export default {
  name: 'CasualGroups',
  data() {
    return {
      casualGroupAddEdit: null,
    }
  },
  props: { user: Object, parent: String },

  components: {
    Button,
    AddEditCasualGroupPopUp,
    SftpDetailsDialog,
    TableHeader,
    TableRow,
  },

  computed: {
    computedHeaders() {
      return [
        {
          text: 'Group Name',
          value: 'name',
          align: 'left',
          class: 'bg-table-heading',
          width: '250px',
          sortable: false,
        },
        {
          text: 'SFTP Access for Sending',
          value: 'Details',
          align: 'left',
          class: 'bg-table-heading',
          width: '250px',
          sortable: false,
        },
        {
          text: this.$t('Delete'),
          value: 'delete',
          align: 'center',
          class: 'bg-table-heading',
        },
      ]
    },
    loggedUserCasualsData() {
      return this.user.casualUsers
    },
    loggedUserGroupsData() {
      return this.user.casualGroups
    },
  },
  emits: ['setGroup'],
  methods: {
    ...mapMutations(['SET_PROCESSING', 'SET_NOTIFICATION']),
    addGroupClicked() {
      this.casualGroupAddEdit = { name: '', casualUsers: [] }
    },
    sftpDetailsUploadingClicked(group) {
      this.$emit('setGroup', group)
    },

    async saveCasualGroupPopUp() {
      try {
        this.SET_PROCESSING(true)

        let isChanged = false

        //for edit
        const groupsArray = this.user.casualGroups.map(group => {
          if (this.casualGroupAddEdit.name === group.name) {
            isChanged = true
            return {
              name: this.casualGroupAddEdit.name,
              casualUsers: this.casualGroupAddEdit.casualUsers,
            }
          } else return group
        })

        //for add
        if (!isChanged) {
          groupsArray.push({
            name: this.casualGroupAddEdit.name,
            casualUsers: this.casualGroupAddEdit.casualUsers,
          })
        }
        console.log('this.parent:' + this.parent)
        if (this.parent === 'user') {
          const res = await api.put(
            `casuals/${this.user.userId}/update-casuals`,
            {
              groups: groupsArray,
              casuals: this.user.casualUsers,
            }
          )

          if (res.status !== 200) throw new Error('Error updating casuals')
          this.user.casualUsers = res.data.casuals
          this.user.casualGroups = res.data.groups
        } else {
          this.user.casualGroups = groupsArray
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.SET_PROCESSING(false)
        this.casualGroupAddEdit = null
      }
    },
    async deleteGroupClicked(i) {
      try {
        this.SET_PROCESSING(true)
        confirmDialog(
          this,
          this.$t('Are you sure you want to delete this group?'),
          this.$t('Delete Group'),
          this.$t('Cancel'),
          async () => {
            try {
              this.user.casualGroups.splice(i, 1)
              const res = await api.put(
                `casuals/${this.user.userId}/update-casuals`,
                {
                  casuals: this.user.casualUsers,
                  groups: this.user.casualGroups,
                }
              )

              if (res.status !== 200) throw new Error('Error updating casuals')
              this.casualUserAddEdit = null
              this.user.casualUsers = res.data.casuals
              this.user.casualGroups = res.data.groups
              this.casualGroupAddEdit = null
            } catch (error) {
              console.log(error)
            }
          }
        )
      } catch (e) {
        console.log(e)
      } finally {
        this.SET_PROCESSING(false)
      }
    },
  },
}
</script>
<style>
.groups-wrapper {
  width: fit-content;
  min-width: 460px;
}
.group-row {
  display: grid;
  grid-template-columns: minmax(150px, max-content) auto auto;
}
</style>
